import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsInformaticaComponent } from './simple-icons-informatica.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsInformaticaComponent ],
    exports:      [ SimpleIconsInformaticaComponent ],
    bootstrap:    []
})
export class SimpleIconsInformaticaModule {}
